@import '../../scss/pk-accordion-group.variables';

:host(.title-host) {
  @apply cursor-pointer;
}

:host(.is-disabled) {
  @apply cursor-default;
}

.title-container {
  @apply button-reset;
  @apply flex w-full items-center justify-between focus-visible:focus-outline hover:enabled:cursor-pointer hover:enabled:text-text-02 disabled:cursor-default disabled:text-text-03;

  font-family: var(--accordion--font-family);

  &.reverse-row {
    @apply flex-row-reverse;

    pk-icon {
      @apply mr-xs;
    }
  }
}

.title {
  @apply flex w-full items-center justify-between text-[color:inherit];
}

.title__left {
  @apply text-[length:--accordion--title-size] text-[color:--accordion--title-color];
}

.title__right {
  .text {
    @apply mx-xl my-0 text-text-03;
  }

  &::slotted([slot='title-right-image']) {
    @apply mr-xs;
  }
}
